const ACCIDENT_TYPE = 'accident';
const CLAIM_TYPE = 'claim';
const VIOLATION_TYPE = 'violation';
const LOSS_TYPE = 'loss';
const quoteIDs = [];
const manualOrderIDs = [];
const assignedViolationIDs = [];
const isRequotedAfterMvr = (quoteID) => {
    return quoteIDs[quoteID] === true;
};
const setRequoteAfterMvr = (quoteID, requote) => {
    quoteIDs[quoteID] = requote;
};

const setManualOrderMvr = (quoteID, value) => {
    manualOrderIDs[quoteID] = value;
}
const isManualOrderMvr = (quoteID) => {
    return manualOrderIDs[quoteID] === true;
};

const setAssignedViolationsForQuote  = (quoteID, value) => {
    assignedViolationIDs[quoteID] = value;
}

const hasAssignedViolationsForQuote  = (quoteID) => {
    return assignedViolationIDs[quoteID] === true;
};

const setAmountFormattedWithCommas = (amount) => {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default {
    getAccidentType: () => ACCIDENT_TYPE,
    getClaimType: () => CLAIM_TYPE,
    getViolationType: () => VIOLATION_TYPE,
    getLossType: () => LOSS_TYPE,
    isAccidentType: (type) => type === ACCIDENT_TYPE,
    isClaimType: (type) => type === CLAIM_TYPE,
    isViolationType: (type) => type === VIOLATION_TYPE,
    isLossType: (type) => type === LOSS_TYPE,

    mvrStatus: {
        NOT_RUN_YET: 'not_run_yet',
        NO_VIOLATIONS: 'no_violations',
        FOUND_VIOLATIONS: 'found_violations'
    },
    setRequoteAfterMvr: setRequoteAfterMvr,
    isRequotedAfterMvr: isRequotedAfterMvr,
    setAmountFormattedWithCommas: setAmountFormattedWithCommas,
    setManualOrderMvr: setManualOrderMvr,
    isManualOrderMvr: isManualOrderMvr,
    setAssignedViolationsForQuote,
    hasAssignedViolationsForQuote
};
